import script from "./NewItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewItemList.vue?vue&type=script&setup=true&lang=js"

import "./NewItemList.vue?vue&type=style&index=0&id=c34cb8ac&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c34cb8ac"]])

export default __exports__